import React from 'react';

const Lock = (props) => {

    const labels = {
        donations: props.advancedInterface ? "donationer" : "regnskab og donationer",
        annualReport: props.advancedInterface ? "regnskab" : "regnskab og donationer"
    }

    const document = labels[props.documentType];

    const unlockMsg = `Er du sikker på at du vil åbne op for enhedens mulighed for at indberette ${document}?`;
    const lockMsg =  `Er du sikker på at du vil låse for enhedens mulighed for at indberette ${document}`;

    if(props.locked) {
        return(
            <div>
                {props.user.type === 'admin' ? 
                <span onClick={() => { if (window.confirm(unlockMsg)) props.handleUnLock(props.documentType)}} style={{cursor: 'pointer'}}>
                    <img alt="Lås op" src="/images/assets/låsblå.svg" title="Lås op" />
                </span>
                 : <img alt="Lås op" src="/images/assets/låsblå.svg" title="Lås op" />
                }
            </div>
        )
    } else {
        return(
            <div>
                {props.user.type === 'admin' ?
                <span onClick={() => { if (window.confirm(lockMsg)) props.handleLock(props.documentType)}} style={{cursor: 'pointer'}}>
                    <img alt="Lås" src="/images/assets/unlock.svg" title="Lås" />
                </span>
                : <img alt="Lås" src="/images/assets/unlock.svg" title="Lås" />
                }
            </div>
        )
    }
}

export default Lock;


// WEBPACK FOOTER //
// ./src/modules/reports/Lock.js